let loadedContainerId = null;

export const loadGoogleTagManager = (containerId) => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;
    if (!containerId || loadedContainerId === containerId) return false;

    const existingScript = Array.from(document.scripts).find((script) => (
        script.dataset.tenderaGtmId === containerId
    ));
    if (existingScript) {
        loadedContainerId = containerId;
        return false;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'gtm.js',
        'gtm.start': new Date().getTime()
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
    script.dataset.tenderaGtmId = containerId;
    document.head.appendChild(script);

    loadedContainerId = containerId;
    return true;
};
